import { render, staticRenderFns } from "./TurnoverWidget.vue?vue&type=template&id=2820334a&"
import script from "./TurnoverWidget.vue?vue&type=script&lang=js&"
export * from "./TurnoverWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports